// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Tcubr","notes":"Notes_notes__2klD_","note":"Notes_note__32BHE","markdown":"Notes_markdown__2Kmro"};